import React from 'react'
import ReactSelect from 'react-select';

const Select = ({ defaultValue, options, onChange, isMulti, placeholder, value }) => {
    return (
        <div>
            <ReactSelect
                defaultValue={defaultValue}
                options={options}
                onChange={onChange}
                isMulti={isMulti || false}
                placeholder={placeholder}
                value={value}
                styles={{
                    control: (base) => ({
                        ...base,
                        backgroundColor: 'transparent',
                        border: '1px solid white',
                        minHeight: '40px',
                        color: 'white',
                        borderRadius: '5px'
                    }),
                    input: (base) => ({
                        ...base,
                        color: 'white',
                        outline: 'none',
                        ":focus" : {
                            outline: 'none'
                        }
                    }),
                    option: (base, state) => ({
                        ...base,
                        color: 'white',
                        backgroundColor: state.isSelected ? '#E96F3A' : 'transparent',
                        margin: '0px',
                        ":hover": {
                            backgroundColor: '#E96F3A',
                        }
                    }),
                    singleValue: (base) => ({
                        ...base,
                        color: 'white',
                        fontSize: '0.8rem',
                        backgroundColor: 'transparent',
                    }),
                    menuList: (base) => ({
                        ...base,
                        backgroundColor: 'black',
                    }),
                    multiValue: (base) => ({
                        ...base,
                        backgroundColor: 'black',
                        border: '1px solid white',
                        borderRadius: '10px'
                    }),
                    placeholder: (base) => ({
                        ...base,
                        fontSize: '0.8rem',
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        ":hover": {
                            backgroundColor: 'none',
                        }
                    }),
                    multiValueLabel: (base) => ({
                        ...base,
                        color: 'white',
                        fontSize: '0.8rem',
                    })
                    
                }}
            />
        </div>
    )
}

export default Select